import styles from './CollapsibleSection.module.scss';

import * as React from 'react';

import { ReactElement, useCallback } from 'react';
import { Stack } from '@fluentui/react';
import { useDispatch, useSelector } from 'react-redux';
import { css } from '../../util/Css';
import { RootState } from '../../redux/types';
import { setCollapsibleSectionClosed } from '../../redux/ui/actions';

interface Props {
  title: string;
  id: string;
  className?: string;
}

export function CollapsibleSection({ title, id, className, children }: React.PropsWithChildren<Props>): ReactElement {
  const sectionsClosed = useSelector((state: RootState) => state.ui.collapsibleSectionsClosed);
  const open = sectionsClosed.indexOf(id) === -1;
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    if (open) {
      dispatch(setCollapsibleSectionClosed(sectionsClosed.concat([id])));
    } else {
      dispatch(setCollapsibleSectionClosed(sectionsClosed.filter((i) => i !== id)));
    }
    // Intentional to not have id, open in dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, sectionsClosed]);

  return (
    <div
      className={css(styles.container, className, {
        opened: open,
        closed: !open,
      })}
    >
      <Stack className={styles.header} horizontal horizontalAlign="space-between" onClick={onClick}>
        <span>{title}</span>
        <i className={`${styles.icon} ms-Icon ms-Icon--${open ? 'ChevronUp' : 'ChevronDown'}`} />
      </Stack>
      {open && <div className={styles.content}>{children}</div>}
    </div>
  );
}
